// src/components/common/Breadcrumbs.js

import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumbs.module.css';
import useAccessibility from 'hooks/useAccessibility';
import Page from 'pages/Page';
import PageType from 'components/pages/PageType';
import { useSubSite } from 'contexts/SubSiteContext'; // Hook pour vérifier le sous-site

const Breadcrumbs = ({ pageType, element, title, category, parent }) => {
  const { isSubSite, subSiteSlug } = useSubSite();
  let breadcrumbs = [];
  breadcrumbs = [{ name: 'Accueil', link: '/' }]; // Toujours commencer par l'accueil

  if (pageType === "isEvent") {
    // Pour les événements, le fil d'Ariane est : Accueil > Agenda > [Titre de l'événement]
    breadcrumbs.push({ name: 'Agenda', link: '/agenda' });
    breadcrumbs.push({ name: element?.title || 'Événement', link: null });

  } else if (pageType === "isOrder") {

    breadcrumbs.push({
      name: "Panier",
      link: "/Panier",
    });
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isPage") {

    // Ajouter la page actuelle (non cliquable)
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isMagazine") {
    breadcrumbs.push({
      name: "Kiosque",
      link: "/kiosque",
    });

    breadcrumbs.push({
      name: element.serie.name,
      link: `/kiosque/${element.serie.slug}`,
    });

    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isNews") {
    if (isSubSite) {
      breadcrumbs.push({
        name: "Actualité",
        link: `/${subSiteSlug}/actualite`,
      });
    }
    else {
      breadcrumbs.push({
        name: "Actualité",
        link: "/actualite",
      });
    }
    breadcrumbs.push({
      name: element.title,
      link: null,
    });

  } else if (pageType === "isAsso") {
    breadcrumbs.push({
      name: "Associations",
      link: "/associations",
    });

    breadcrumbs.push({
      name: element.name,
      link: null,
    });
  } else if (pageType === "isCategory") {
    if (parent) {
      breadcrumbs.push({
        name: parent.name,
        link: `/categorie/${parent.slug}`,
      });
    }
    // Pour les catégories, le fil d'Ariane est : Accueil > [Nom de la catégorie]
    breadcrumbs.push({
      name: title,
      link: null,
    });


  } else if (pageType === "isProgramme") {
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isConcerts") {
    breadcrumbs.push({
      name: "Le Programme",
      link: `/programme`,
    });
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isSpectacles") {
    breadcrumbs.push({
      name: "Le Programme",
      link: `/programme`,
    });
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isSpectacle") {
    breadcrumbs.push({
      name: "Le Programme",
      link: `/programme`,
    });
    breadcrumbs.push({
      name: "Les Spectacles",
      link: `/programme/spectacle`,
    });
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isConcert") {
    breadcrumbs.push({
      name: "Le Programme",
      link: `/programme`,
    });
    breadcrumbs.push({
      name: "Les Concerts",
      link: `/programme/concert`,
    });
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else if (pageType === "isMonCompte") {

    // Ajouter la page actuelle (non cliquable)
    breadcrumbs.push({
      name: element.title,
      link: null,
    });
  } else {
    breadcrumbs.push({
      name: title,
      link: null,
    });
  }

  return (
    <nav aria-label="Fil d'Ariane" className={styles.breadcrumbs}>
      <ul>
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            {crumb.link ? (
              <Link to={crumb.link}>{crumb.name}</Link>
            ) : (
              <span>{crumb.name}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
